import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'projects/chat-common/src/lib/services/auth.service';
import { catchError, finalize, switchMap, take, tap, EMPTY } from 'rxjs';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent {
  registerForm: FormGroup;
  registerError: string | null = null;
  isLoading = false;

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private router: Router
  ) {
    this.registerForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      name: ['', [Validators.required, Validators.minLength(2)]],
    });
  }

  get name(): FormControl {
    return this.registerForm.get('name') as FormControl;
  }
  get email(): FormControl {
    return this.registerForm.get('email') as FormControl;
  }
  get password(): FormControl {
    return this.registerForm.get('password') as FormControl;
  }

  ngOnInit() {}

  attemptRegister(): void {
    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    const name = (this.name.value || '').trim();
    const email = (this.email.value || '').trim().toLowerCase();
    const password = this.password.value;

    this.isLoading = true;
    this.registerError = null;

    this.auth
      .checkEmailAvailability(email)
      .pipe(
        take(1),
        switchMap((available: boolean) => {
          if (!available) {
            this.router.navigate(['login']);
            return EMPTY;
          }
          return this.auth.register(name, email, password).pipe(
            tap(() => {
              this.router.navigate(['health-assistant']);
            })
          );
        }),
        catchError((e) => {
          this.registerError = 'Registration failed. Please try again.';
          return EMPTY;
        }),
        finalize(() => (this.isLoading = false))
      )
      .subscribe();
  }

  onSubmit(): void {
    this.attemptRegister();
  }

  isFieldInvalid(field: string): boolean {
    const c = this.registerForm.get(field);
    return !!(c && c.invalid && (c.dirty || c.touched));
  }
}
